import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { Modal, Row, Col } from 'react-bootstrap';
import Alert from 'components/ui/Alert';
import { sluggify } from 'utils/localization/utils';
import { checkEquipmentExists } from 'utils/EquipmentWebAPIUtils';
import AddEquipmentForm from '../equipment/AddEquipmentForm';
import EquipmentSearch from './equipments/EquipmentSearch';

class AddEquipmentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addEquipmentFormVisible: false,
      addNewEquipmentError: null,
    };
  }

  handleClose = () => this.props.onClose();
  handleAddEquipment = () => this.setState({ addEquipmentFormVisible: true });
  handleCancelAddEquipment = () =>
    this.setState({ addEquipmentFormVisible: false });
  handleCreateEquipment = async (equipment) => {
    try {
      const { entity: equipmentData } = await checkEquipmentExists(equipment);
      if (equipmentData.exists === true) {
        this.setState({ addNewEquipmentError: 'EQUIPMENT_ALREADY_EXIST' });
      }
      if (equipmentData.exists === false) {
        this.setState(
          { addNewEquipmentError: null, addEquipmentFormVisible: false },
          () => this.props.onCreateEquipment(equipment),
        );
      }
    } catch (e) {
      if (sluggify(e.entity.message) === 'EQUIPMENT_MISMATCH') {
        this.setState({ addNewEquipmentError: 'MISMATCHED_EQUIPMENT_TYPE' });
      }
    }
  };

  render() {
    const { show, onEquipmentSelect, orderEquipment, t } = this.props;
    const { addNewEquipmentError } = this.state;
    return (
      <Modal show={show} enforceFocus={false}>
        <Modal.Header>
          <Modal.Title>{t('ADD_EQUIPMENT_ORDER')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className="text-grey-dark mb-4">{titleize(t('EQUIPMENT'))}</h4>
          <fieldset className="mb-4">
            <label className="field-label mb-2 w-full">
              {t('ENTER_EQUIPMENT_TO_ADD')}
            </label>

            <div className="equipment-search-wrapper">
              <EquipmentSearch
                onEquipmentSelect={onEquipmentSelect}
                orderEquipment={orderEquipment}
              />
            </div>
          </fieldset>
          <div className="separator mb-4">
            <div className="separator-text">
              <div className="separator-circle">{t('OR')}</div>
            </div>
          </div>
          {this.state.addEquipmentFormVisible && (
            <div className="bg-grey-lightest my-4 p-4">
              {addNewEquipmentError && (
                <Alert title={t('ERRORS')} type="error">
                  <ul>
                    <li key={1}>{t(addNewEquipmentError)}</li>
                  </ul>
                </Alert>
              )}
              <AddEquipmentForm
                onSave={this.handleCreateEquipment}
                onCancel={this.handleCancelAddEquipment}
              />
            </div>
          )}
          {!this.state.addEquipmentFormVisible && (
            <button
              className="button button-hollow-green"
              onClick={this.handleAddEquipment}
            >
              <i className="fa fa-plus" />
              <span>{t('ADD_NEW_EQUIPMENT')}</span>
            </button>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={9} sm={10} />
            <Col xs={3} sm={2}>
              <button
                className="button bg-white text-grey hover:text-grey-dark"
                onClick={this.handleClose}
              >
                {titleize(t('CLOSE'))}
              </button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  }
}

AddEquipmentModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  orderEquipment: PropTypes.array,
  onCreateEquipment: PropTypes.func.isRequired,
  onEquipmentSelect: PropTypes.func.isRequired,
};

export default withTranslation()(AddEquipmentModal);
